export default __webpack_public_path__ + "static/media/O-053.bd6983ae.png";